import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { Tooltip } from "antd";
import {
  LabelDataHeading,
  ValueDataHeading,
  UnderlyingContent,
  ContentDivider,
  CustomizedIcon,
} from "../../../style";
import { addressFormat } from "../../../utils";
import { removeNtee } from "../../../../../../../CommonComponents/CharitySearch/utils";
import { CapsuleButton } from "../../../../../../../CommonComponents/Commons/commonComponents";

export const savedCharityRender = ({
  data,
  savedCharityModal,
  removeSavedCharityModal,
}) => {
  if (data.loading) {
    return <CustomizedIcon type="star" />;
  }
  return data.isSelected ? (
    <CustomizedIcon
      data-test="saved-charity-section"
      type="star"
      theme="filled"
      onClick={() => savedCharityModal(data)}
    />
  ) : (
    <CustomizedIcon
      data-test="saved-charity-section-not-selected"
      type="star"
      theme="outlined"
      onClick={() => removeSavedCharityModal(data)}
    />
  );
};

export default function SearchCharityCard({
  data,
  pendingCharityHandler,
  removeSavedCharityModal,
  savedCharityModal,
  activityBlocked = "",
  searchResultClickHandler,
}) {
  return (
    <div>
      <Row type="flex">
        <Col span={2}>
          {savedCharityRender({
            data,
            savedCharityModal,
            removeSavedCharityModal,
          })}
        </Col>
        <Col span={22}>
          <UnderlyingContent
            data-test="under-link"
            onClick={() => searchResultClickHandler(data.ein)}
            target="_blank"
          >
            {data.organization_name}{" "}
          </UnderlyingContent>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <LabelDataHeading>EIN</LabelDataHeading>
          <ValueDataHeading>{data.ein}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <LabelDataHeading>Address</LabelDataHeading>
          <Tooltip
            placement="bottom"
            title={addressFormat({
              addressLine1: data.address_line_1,
              addressLine2: data.address_line_2,
              city: data.city,
              state: data.state,
              zipCode: data.zip,
            })}
          >
            <UnderlyingContent>
              {data.city + "," + data.state}
            </UnderlyingContent>
          </Tooltip>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={23}>
          <LabelDataHeading>Interest Area</LabelDataHeading>
          <ValueDataHeading>
            {data.ntee_code ? removeNtee(data.ntee_code) : ""}
          </ValueDataHeading>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={8}>
          <CapsuleButton
            data-test="capsule-button"
            onClick={() => pendingCharityHandler(data)}
            disabled={!!activityBlocked || data.loading}
            title={activityBlocked}
            text="Select"
            whiteBackground
            iconType="arrowRight"
            alt  = "select charity"
          />
        </Col>
        <Col span={16}></Col>
      </Row>
    </div>
  );
}

SearchCharityCard.propTypes = {
  activityBlocked: PropTypes.string,
  data: PropTypes.shape({
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    also_known_as: PropTypes.any,
    bmf_assets: PropTypes.string,
    bmf_gross_receipts: PropTypes.string,
    bridge_id: PropTypes.any,
    city: PropTypes.string,
    contact_email: PropTypes.any,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
    contact_title: PropTypes.string,
    county: PropTypes.string,
    ein: PropTypes.string,
    form_type: PropTypes.string,
    foundation_code: PropTypes.string,
    isSelected: PropTypes.bool,
    lat_long: PropTypes.string,
    mission: PropTypes.string,
    ntee_code: PropTypes.string,
    number_of_employees: PropTypes.string,
    organization_id: PropTypes.string,
    organization_name: PropTypes.string,
    parent_orgs: PropTypes.any,
    profile_level: PropTypes.any,
    properties: PropTypes.object,
    public_report: PropTypes.any,
    state: PropTypes.any,
    subsection_code: PropTypes.string,
    website_url: PropTypes.string,
    zip: PropTypes.string,
  }),
  pendingCharityHandler: PropTypes.func,
  removeSavedCharityModal: PropTypes.func,
  savedCharityModal: PropTypes.func,
  searchResultClickHandler: PropTypes.func,
};
